import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { StandardService } from "../services/standard.service";
import { Subject } from "rxjs";
import { debounceTime, switchMap } from "rxjs/operators";

@Component({
  selector: "app-search-suggestions",
  templateUrl: "./search-suggestions.component.html",
  styleUrls: ["./search-suggestions.component.scss"],
})
export class SearchSuggestions implements OnChanges {
  allSuggestions: any;
  loading: boolean = false;

  @Input() query: string;
  @Input() typeID: number;

  private queryChanged: Subject<{ query: string; typeID: number }> =
    new Subject();

  constructor(private router: Router, public standardService: StandardService) {
    this.queryChanged
      .pipe(
        debounceTime(500),
        switchMap(({ query, typeID }) =>
          this.standardService.searchAllSuggestions(query, typeID)
        )
      )
      .subscribe((data) => {
        this.allSuggestions = data;
        this.loading = false;
        console.log("All sugges", this.allSuggestions);
      });
  }

  @Input() results: any = [
    { Title: "Drive Thru", Type: "Global Approved Solution" },
    { Title: "Restaturant global standards", Type: "Global Approved Solution" },
    // ...etc
  ];

  ngOnChanges(changes: SimpleChanges) {
    this.loading = true;
    if (changes["query"] && !changes["query"].firstChange) {
      this.queryChanged.next({ query: this.query, typeID: this.typeID });
    } else {
      this.queryChanged.next({ query: this.query, typeID: this.typeID });
    }
  }

  // navigateToDetail(result: any) {
  //   this.router.navigate(["/details", result.id]);
  // }
  apply() {
    this.router.navigate(["/standards-search"], {
      queryParams: { query: this.query, type: this.typeID },
    });
  }

  rowSelected(item: any): void {
    if (item.isUpcoming) {
      this.router.navigate(["/view-upcoming-standard-detail/" + item.id]);
      return;
    }

    switch (item.standardTypeId) {
      case 1:
        this.router.navigate([
          "/global-recommendations-detail-view/" + item.id,
        ]);
        break;

      case 3:
        this.router.navigate(["/nrbes-view/" + item.id]);
        break;
      case 4:
        this.router.navigate(["/minimum-standard-detail-view/" + item.id]);
        break;
      case 5:
        this.router.navigate(["/view-equipments-standard-detail/" + item.id]);
        break;
      case 6:
          this.router.navigate(["/view-national-equipments-standard-detail/" + item.id]);
          break;  

      case 7:
        this.router.navigate(["/nrbes-view/" + item.id]);
        break;

      case 8:
        this.router.navigate(["/operations-standards-detail-view/" + item.id]);
        break;
    }
  }

  // getSuggestions() {
  //   this.standardService.getLatestModifiedStandards().subscribe((response: any) => {
  //     this.allSuggestions = response.standardDetailList;
  //     console.log('All sugg', response.standardDetailList);
  //     this.loading = false;
  //   });
  // }

  getStandardTypeName(id: number): string {
    let standardTYpeName: string = "";
    switch (id) {
      case 1:
        return (standardTYpeName = "Global Approved Solution");
      case 2:
        return (standardTYpeName = "Market Best Practices");
      case 3:
        return (standardTYpeName = "Market Standard");
      case 4:
        return (standardTYpeName = "Global Building Restaurant Standard");
      case 5:
        return (standardTYpeName = "Global Equipment Standard");
      case 6:
        return (standardTYpeName = "Local Equipment Standard");
      case 7:
        return (standardTYpeName = "BU Standard");
      case 8:
        return (standardTYpeName = "Global Operation Standard");
    }
  }
}
